import React from "react";
import { useMessageSource } from "react-message-source";
import RadioButtonField from "../formik/radiobutton";
import { Grid } from "@mui/material";

export default function Gender({
  forceReRender,
  dataPath = "",
}: {
  forceReRender?: boolean;
  dataPath?: string;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const idBase = dataPath ? dataPath : "gender";
  return (
    <Grid className="scd-container-base" size={{ xs: 12, md: 6 }}>
      <RadioButtonField
        wrap={false}
        forceReRender={forceReRender}
        title={getMessage("Gender")}
        id={`${dataPath}gender`}
        name={`${dataPath}gender`}
        values={[
          {
            id: `${idBase}-mr`,
            value: "MALE",
            label: getMessage("Gender.MR"),
          },
          {
            id: `${idBase}-ms`,
            value: "FEMALE",
            label: getMessage("Gender.MS"),
          },
        ]}
      />
    </Grid>
  );
}
